import { render, staticRenderFns } from "./ShareModel.vue?vue&type=template&id=64dcc3f9&scoped=true&"
import script from "./ShareModel.vue?vue&type=script&lang=ts&"
export * from "./ShareModel.vue?vue&type=script&lang=ts&"
import style0 from "./ShareModel.vue?vue&type=style&index=0&id=64dcc3f9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64dcc3f9",
  null
  
)

export default component.exports